/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { darken } from 'polished'; // Assuming a utility function for color manipulation
import Mixin from '../../../util/mixin';

export class TextEmphasisVariant extends Mixin {
  style({$}, [parent, color, ignoreWarning = false]) {
    return css`
      ${parent} {
        color: ${color} !important;
      }

      ${$.emphasizedLinkHoverDarkenPercentage !== 0 &&
      css`
        a${parent}:hover,
        a${parent}:focus {
          color: ${darken($.emphasizedLinkHoverDarkenPercentage, color)} !important;
        }
      `}
    `;
  }
};
